<template>
    <bill-shell default-title="Moovah Vehicle Insurance">
        <section id="more" class="section py-5 bg-white">
            <div class="container text-left">
                <h1 class="text-8 font-weight-bold mb-4 mt-2">
                    Buy Your Vehicle Insurance & ZINARA Licence online with Magetsi!
                </h1>
                <p class="text-3">
                    Save time and skip the queue! Renew your ZINARA license quickly and conveniently from the comfort of your home with Magetsi.
                </p>
                <p class="text-3">
                    Here's how easy it is:
                </p>
                <ul>
                    <li>Fast & Simple: In just a few clicks your transaction will be completed.</li>
                    <li>Secure Payments: Our secure online payment gateway ensures your information is safe.</li>
                    <li>Disc Delivered: Get your ZINARA license disc delivered straight to your doorstep (free delivery! T&Cs apply).</li>
                </ul>
            </div>
        </section>
        <section class="section py-5 bg-light-4">
            <div class="container">
                <h2 class="text-7 font-weight-bold mb-4 text-left">
                    Why You Should Pay for Your Car Insurance, Zinara & Radio License.
                </h2>
                <h3 class="text-5 font-weight-bold mb-4 text-left">
                    Protect Yourself Financially
                </h3>
                <p class="text-3 mb-4 text-left">
                    One of the primary reasons to pay for car insurance is financial protection. In the event of an accident, your insurance can cover the costs of repairs, medical expenses, and legal fees, saving you from significant out-of-pocket expenses.
                </p>
                <h3 class="text-5 font-weight-bold mb-4 text-left">
                    Legal Requirement
                </h3>
                <p class="text-3 mb-4 text-left">
                    In Zimbabwe, having car insurance is a legal requirement. Driving without insurance can lead to hefty fines, license suspension, and even legal action. Ensuring you have the necessary coverage keeps you compliant with the law and avoids these penalties.
                </p>
                <h3 class="text-5 font-weight-bold mb-4 text-left">
                    Peace of Mind
                </h3>
                <p class="text-3 mb-4 text-left">
                    Car insurance provides peace of mind. Knowing you’re covered in case of an accident, theft, or other unexpected events allows you to drive with confidence, without worrying about the potential financial repercussions.
                </p>
                <h3 class="text-5 font-weight-bold mb-4 text-left">
                    Coverage for Damages
                </h3>
                <p class="text-3 mb-4 text-left">
                    Car insurance covers damages to your vehicle resulting from accidents, natural disasters, vandalism, and theft. This ensures that you can repair or replace your car without bearing the full cost yourself.
                </p>
                <h3 class="text-5 font-weight-bold mb-4 text-left">
                    Liability Protection
                </h3>
                <p class="text-3 mb-4 text-left">
                    If you cause an accident, you could be held responsible for the damages and injuries to other parties. Liability coverage in your car insurance policy helps pay for these costs, protecting your personal assets from being used to settle claims.
               </p>
                <h3 class="text-5 font-weight-bold mb-4 text-left">
                    Medical Expenses
                </h3>
                <p class="text-3 mb-4 text-left">
                    In the unfortunate event of an accident, car insurance can cover medical expenses for you, your passengers, and others involved. This can include hospital bills, rehabilitation, and even lost wages if injuries prevent you from working.
                    <br>
                    ZINARA's mandate includes the collection, allocation, and management of road user fees for road authorities. Additionally, ZINARA is tasked with generating revenue for the development and maintenance of roads. In the past, Radio license was not mandatory for car users but as of May 2024, the government has made it mandatory as a way to raise funds to promote ZBC.
                </p>
            </div>
        </section>
        <section id="more" class="section py-5 bg-white">
            <div class="container text-left">
                <h2 class="text-7 font-weight-bold mb-4 mt-2">
                    Zinara licensing Fees
                </h2>
                <div class="table-responsive">
                    <table class="table">
                        <tbody>
                        <tr class="text-black-50">
                            <th>Vehicle Class (Net Mass in kg)</th>
                            <th>USD Indexed Fees</th>
                            <th>4 Months Fees in ZWG</th>
                            <th>6 Months Fees in ZWG</th>
                            <th>8 Months Fees in ZWG</th>
                            <th>10 Months Fees in ZWG</th>
                            <th>12 Months Fees in ZWG</th>
                        </tr>
                        <tr v-for="fee in zinara_fees">
                            <td>{{ fee.vehicle }}</td>
                            <td>{{ fee.index }}</td>
                            <td>{{ fee.four }}</td>
                            <td>{{ fee.six }}</td>
                            <td>{{ fee.eight }}</td>
                            <td>{{ fee.ten }}</td>
                            <td>{{ fee.twelve }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
        <section class="section py-5 bg-light-4">
            <div class="container">
                <h2 class="text-7 font-weight-bold mb-4 mt-2">
                    ZINARA Tollgate Fees For Other Roads
                </h2>
                <div class="table-responsive">
                    <table class="table">
                        <tbody>
                        <tr class="text-black-50">
                            <th>Vehicle Type</th>
                            <th>Toll Gate Fees in USD</th>
                            <th>Toll Gate Fees in ZWG</th>
                        </tr>
                        <tr v-for="fee in zinara_fees">
                            <td>{{ fee.vehicle }}</td>
                            <td>{{ fee.index }}</td>
                            <td>{{ fee.four }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
    </bill-shell>
</template>

<script>
import BillShell from "./bill-shell.vue";

export default {
    name: "ZinaraShell",
    components: {BillShell, WelcomeInfo: () => import("../shared/welcome-info")},
    data: function () {
        return {
            zinara_fees: [
                {
                    vehicle: 'Up to 1500kg',
                    index: '40',
                    four: ' ZWG 1 000.00',
                    six: 'ZWG 1 500.00',
                    eight: 'ZWG 2 000.00',
                    ten: 'ZWG 2 500.00',
                    twelve: 'ZWG 3 000.00'
                },
                {
                    vehicle: '1501kg - 2250kg',
                    index: '50',
                    four: ' ZWG 1 250.00',
                    six: 'ZWG 1 875.50',
                    eight: 'ZWG 2 500.00',
                    ten: 'ZWG 3 125.00',
                    twelve: 'ZWG 3 750.00'
                },
                {
                    vehicle: '2251kg - 3000kg',
                    index: '60',
                    four: ' ZWG 1 500.00',
                    six: 'ZWG 2 250.00',
                    eight: 'ZWG 3 000.00',
                    ten: 'ZWG 3 750.00',
                    twelve: 'ZWG 4 500.00'
                },
                {
                    vehicle: '3001kg - 3750kg',
                    index: '120',
                    four: ' ZWG 3 000.00',
                    six: 'ZWG 4 500.00',
                    eight: 'ZWG 6 000.00',
                    ten: 'ZWG 7 500.00',
                    twelve: 'ZWG 9 000.00'
                },
                {
                    vehicle: '3751kg - 4250kg',
                    index: '150',
                    four: ' ZWG 3 750.00',
                    six: 'ZWG 5 635.00',
                    eight: 'ZWG 7 500.00',
                    ten: 'ZWG 9 375.00',
                    twelve: 'ZWG 11 250.00'
                },
                {
                    vehicle: '4251kg - 5000kg',
                    index: '180',
                    four: 'ZWG 4 500.00',
                    six: 'ZWG 6 750.00',
                    eight: 'ZWG 9 000.00',
                    ten: 'ZWG 11 250.00',
                    twelve: 'ZWG 13 500.00'
                },
                {
                    vehicle: '5001kg - 5750kg',
                    index: '200',
                    four: 'ZWG 5 000.00',
                    six: 'ZWG 7 500.00',
                    eight: 'ZWG 10 000.00',
                    ten: 'ZWG 12 500.00',
                    twelve: 'ZWG 15 000.00'
                },
                {
                    vehicle: '5751kg - 6250kg',
                    index: '210',
                    four: 'ZWG 5 250.00',
                    six: 'ZWG 7 875.00',
                    eight: 'ZWG 10 500.00',
                    ten: 'ZWG 13 125.50',
                    twelve: 'ZWG 15 750.00'
                },
                {
                    vehicle: '6251kg - 7000kg',
                    index: '240',
                    four: 'ZWG 6 000.00',
                    six: 'ZWG 9 000.00',
                    eight: 'ZWG 12 000.00',
                    ten: 'ZWG 15 000.00',
                    twelve: 'ZWG 18 000.00'
                },
                {
                    vehicle: '7001kg - 7750kg',
                    index: '260',
                    four: 'ZWG 6 500.00',
                    six: 'ZWG 9 750.00',
                    eight: 'ZWG 13 000.00',
                    ten: 'ZWG 16 250.00',
                    twelve: 'ZWG 19 500.00'
                },
                {
                    vehicle: '7751kg - 9250kg',
                    index: '280',
                    four: 'ZWG 7 000.00',
                    six: 'ZWG 10 500.00',
                    eight: 'ZWG 14 000.00',
                    ten: 'ZWG 17 500.00',
                    twelve: 'ZWG 21 000.00'
                },
                {
                    vehicle: '9251kg-10000kg',
                    index: '300',
                    four: 'ZWG 7 500.00',
                    six: 'ZWG 11 250.00',
                    eight: 'ZWG 15 000.00',
                    ten: 'ZWG 18 750.00',
                    twelve: 'ZWG 22 500.00'
                },
                {
                    vehicle: '10001kg-10750kg',
                    index: '400',
                    four: 'ZWG 10 000.00',
                    six: 'ZWG 15 000.00',
                    eight: 'ZWG 20 000.00',
                    ten: 'ZWG 25 000.00',
                    twelve: 'ZWG 30 000.00'
                },
                {
                    vehicle: '10751kg and above',
                    index: '600',
                    four: 'ZWG 15 000.00',
                    six: 'ZWG 22 500.00',
                    eight: 'ZWG 30 000.00',
                    ten: 'ZWG 37 500.00',
                    twelve: 'ZWG 45 000.00'
                }
            ],
           tollgate_fees: [
                {
                    vehicle: 'Motorcycles',
                    usd: 'US$0.00',
                    zig: 'ZWG 0.00'
                },
               {
                   vehicle: 'Light Vehicles',
                   usd: 'US$4.00',
                   zig: ' ZWG 100.00'
               },
               {
                   vehicle: 'Minibuses',
                   usd: 'US$6.00',
                   zig: ' ZWG 150.00'
               },
               {
                   vehicle: 'Buses',
                   usd: 'US$8.00',
                   zig: ' ZWG 200.00'
               },
               {
                   vehicle: 'Heavy Vehicles',
                   usd: 'US$10.00',
                   zig: ' ZWG 250.00'
               },
               {
                   vehicle: 'Haulage Trucks',
                   usd: 'US$20.00',
                   zig: ' ZWG 500.00'
               },
               {
                   vehicle: 'Residential Per Term',
                   usd: 'US$80.00',
                   zig: ' ZWG 2000.00'
               }
            ]
        };
    },
    mounted() {
        document.querySelector('meta[name="description"]').setAttribute("content", "Do You Want To pay for your Vehicle Insurance, ZINARA and ZBC online?");
    }

}
</script>
